export default __webpack_public_path__ + "static/why-2-5ad540a005bbb1bcd9ec7f248afe51e8.svg";